import React from 'react';

/**
 * Shared component for displaying "No projects found" message
 * Used in both CardView and TableView when no projects match the current filters
 */
export const EmptyStateMessage = () => (
  <div className="sui-text-center sui-py-8" data-testid="no-results-message">
    <div className="sui-text-lg sui-font-bold sui-text-gray-600">No projects found</div>
    <div className="sui-text-sm sui-text-gray-500 sui-mt-2">
      Try adjusting your filters to see more results
    </div>
  </div>
);
